export default __webpack_public_path__ + "static/media/Letters1_21.366ae512.png";